const { uniq } = require('lodash');
const { slugify } = require('@zapier/common-utils');

const X_FRAME_EXEMPT = {
  // use if the route is permitted to be embedded. we will still check
  // if the embedding is permitted (whitelisted)
  EXEMPT: 'exempt',
};

function buildRoute(route) {
  const name = route.name || slugify(route.pattern.replace(/\/app\//g, ''));

  console.info(`[DEFINE ROUTE] ${name} → ${route.pattern}`);

  return {
    isXFrameExempt: X_FRAME_EXEMPT.EXEMPT,
    ...route,
    name,
  };
}

function buildRoutes(routes) {
  const built = routes.map(buildRoute);
  const names = built.map(({ name }) => name);
  if (uniq(names).length !== names.length) {
    console.error(`🛑 Duplicate route names exist`);
  }
  return built;
}

const routes = [
  // No god-like route delegating to a god-like Editor component!
  // Instead, one route / component per page.
  {
    name: 'make-a-zap',
    pattern: '/app/editor',
    page: '/editor',
  },

  /////////////////////////////////////////////////////////
  // Shared Zaps
  /////////////////////////////////////////////////////////
  {
    name: 'shared-zap-redirect',
    pattern: '/app/editor/shared-zap/:szid',
    page: '/shared-zap',
  },
  {
    name: 'shared-redirect',
    pattern: '/app/editor/shared/:guid',
    page: '/shared',
  },

  /////////////////////////////////////////////////////////
  // Zap Templates
  /////////////////////////////////////////////////////////
  {
    name: 'template',
    pattern: '/app/editor/template/:zapTemplateId',
    page: '/editor',
  },
  {
    name: 'template-page',
    pattern: '/app/editor/template/:zapTemplateId/:pageKey',
    page: '/editor',
  },
  {
    name: 'zap-template',
    pattern: '/app/editor/zap-template/:zapTemplateId',
    page: '/editor',
  },
  {
    name: 'zap-template-overview',
    pattern: '/app/editor/zap-template/:zapId/overview',
    page: '/overview',
  },
  // Per-sub-step (pageKey) SSR pages for Zap Templates
  {
    pattern: '/app/editor/zap-template/:zapId/:nodes/:stepId/setup',
    page: '/substeps/setup',
  },
  {
    pattern: '/app/editor/zap-template/:zapId/:nodes/:stepId/auth',
    page: '/substeps/auth',
  },
  {
    pattern: '/app/editor/zap-template/:zapId/:nodes/:stepId/webhook',
    page: '/substeps/webhook',
  },
  {
    pattern: '/app/editor/zap-template/:zapId/:nodes/:stepId/fields',
    page: '/substeps/fields',
  },
  {
    pattern: '/app/editor/zap-template/:zapId/:nodes/:stepId/filter',
    page: '/substeps/filter',
  },
  {
    pattern: '/app/editor/zap-template/:zapId/:nodes/:stepId/path',
    page: '/substeps/path',
  },
  {
    pattern: '/app/editor/zap-template/:zapId/:nodes/:stepId/rules',
    page: '/substeps/rules',
  },
  {
    pattern: '/app/editor/zap-template/:zapId/:nodes/:stepId/sample',
    page: '/substeps/sample',
  },
  // This will catch any other ZT sub-steps
  {
    name: 'zap-template-sub-step-catch-all',
    pattern: '/app/editor/zap-template/:zapId/:nodes/:stepId/:pageKey',
    page: '/editor',
  },

  /////////////////////////////////////////////////////////
  // The Editor
  /////////////////////////////////////////////////////////
  {
    name: 'zap',
    pattern: '/app/editor/:zapId',
    page: '/editor',
  },
  {
    name: 'zap-overview',
    pattern: '/app/editor/:zapId/overview',
    page: '/overview',
  },
  {
    name: 'zap-step',
    pattern: '/app/editor/:zapId/:nodes/:stepId',
    page: '/editor',
  },
  // Per-sub-step (pageKey) SSR pages
  {
    pattern: '/app/editor/:zapId/:nodes/:stepId/setup',
    page: '/substeps/setup',
  },
  {
    pattern: '/app/editor/:zapId/:nodes/:stepId/auth',
    page: '/substeps/auth',
  },
  {
    pattern: '/app/editor/:zapId/:nodes/:stepId/webhook',
    page: '/substeps/webhook',
  },
  {
    pattern: '/app/editor/:zapId/:nodes/:stepId/fields',
    page: '/substeps/fields',
  },
  {
    pattern: '/app/editor/:zapId/:nodes/:stepId/filter',
    page: '/substeps/filter',
  },
  {
    pattern: '/app/editor/:zapId/:nodes/:stepId/path',
    page: '/substeps/path',
  },
  {
    pattern: '/app/editor/:zapId/:nodes/:stepId/rules',
    page: '/substeps/rules',
  },
  {
    pattern: '/app/editor/:zapId/:nodes/:stepId/sample',
    page: '/substeps/sample',
  },
  // This will catch any other sub-steps
  {
    name: 'zap-sub-step-catch-all',
    pattern: '/app/editor/:zapId/:nodes/:stepId/:pageKey',
    page: '/editor',
  },

  /////////////////////////////////////////////////////////
  // Embedded Editor Testing
  /////////////////////////////////////////////////////////
  {
    name: 'embedded-editor-test',
    pattern: '/embedded-editor-test',
    page: '/embedded-editor-test',
  },
];

module.exports = buildRoutes(routes);
